export enum Cookie {
  AccessToken = 'accessToken',
  RefreshToken = 'refreshToken',
  ResetPasswordToken = 'resetPasswordToken',
}
